import React from 'react';
import styled from 'styled-components';

import { Flex } from 'Components/Base';

const ContentContainer = styled((props) => <Flex {...props} />)`
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding: 44px 24px 24px 24px;
`;

export default ContentContainer;
